import { Eyebrow, Icon } from '../components/primitives';

export const HowItFits = () => {
  const flow = [
    {
      eye: 'ENGINE',
      t: 'Build your Ruleset',
      b: 'Define attributes, archetypes, items, and scripted rules. Design character sheets in the Page Editor.',
    },
    {
      eye: 'STOREFRONT',
      t: 'Publish to questbound.com',
      b: 'Cover, pricing, modules. Stripe-connected, customer accounts handled.',
    },
    {
      eye: 'PLAYER APP',
      t: 'Players install and play',
      b: 'A deployed progressive web app. Offline, on every device, alongside their VTT or at the table.',
    },
    {
      eye: 'DASHBOARD',
      t: 'Sales + activity, real-time',
      b: 'Watch what works. Iterate. Ship modules. Watch the next wave of sales.',
    },
  ];
  return (
    <section
      className="qb-section-tight"
      style={{ padding: '120px 40px', borderBottom: '1px solid var(--qb-border-soft)' }}>
      <div style={{ maxWidth: 1280, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: 64 }}>
          <Eyebrow>ONE PLATFORM · END TO END</Eyebrow>
          <h2
            className="qb-howitfits-h2"
            style={{
              fontFamily: 'var(--qb-font-display)',
              textTransform: 'uppercase',
              fontSize: 64,
              lineHeight: 0.95,
              letterSpacing: '-0.015em',
              margin: '16px auto 16px',
              maxWidth: 900,
              textWrap: 'balance',
            }}>
            From a notebook of ideas to a{' '}
            <span style={{ color: 'var(--qb-orange-500)' }}>game</span> people are paying to play.
          </h2>
          <p
            style={{
              fontFamily: 'var(--qb-font-body)',
              fontSize: 18,
              lineHeight: 1.55,
              color: 'var(--qb-fg-muted)',
              margin: '0 auto',
              maxWidth: 660,
              fontStyle: 'italic',
            }}>
            Quest Bound is like Wix or Shopify, except you're building a dynamic digital TTRPG
            instead of a t-shirt store.
          </p>
        </div>

        <div
          className="qb-howitfits-grid"
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gap: 0,
            border: '1px solid var(--qb-border-strong)',
          }}>
          {flow.map((f, i) => (
            <div
              key={f.eye}
              style={{
                padding: '26px 24px 28px',
                borderRight: i < 3 ? '1px solid var(--qb-border-strong)' : 'none',
                background: i === 1 || i === 3 ? 'var(--qb-ink-800)' : 'transparent',
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                gap: 10,
                minHeight: 220,
              }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <span
                  style={{
                    fontFamily: 'var(--qb-font-display)',
                    fontSize: 11,
                    letterSpacing: '0.16em',
                    color: 'var(--qb-orange-500)',
                  }}>
                  0{i + 1}
                </span>
                <Eyebrow>{f.eye}</Eyebrow>
              </div>
              <h3
                style={{
                  fontFamily: 'var(--qb-font-display)',
                  textTransform: 'uppercase',
                  fontSize: 22,
                  lineHeight: 1.1,
                  margin: 0,
                  color: 'var(--qb-fg)',
                }}>
                {f.t}
              </h3>
              <p
                style={{
                  fontFamily: 'var(--qb-font-body)',
                  fontSize: 14,
                  lineHeight: 1.55,
                  color: 'var(--qb-fg-muted)',
                  margin: 0,
                }}>
                {f.b}
              </p>
              {i < 3 && (
                <div
                  className="qb-howitfits-arrow"
                  style={{
                    position: 'absolute',
                    right: -10,
                    top: 'calc(50% - 10px)',
                    width: 20,
                    height: 20,
                    background: 'var(--qb-orange-500)',
                    border: '2px solid var(--qb-ink-900)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 2,
                    color: '#fff',
                  }}>
                  <Icon s={12} d="M5 12h14m0 0-5-5m5 5-5 5" />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
